import { Button, Modal } from '@react-apps/design-system';
import { ErrorText, getApiErrorMessage } from '../display';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  confirmLabel?: string;
  loading?: boolean;
  error?: unknown;
}

export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirmar',
  loading,
  error,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
    >
      <div className="space-y-4">
        {error != null && (
          <ErrorText>
            {getApiErrorMessage(error, 'Falha na operação')}
          </ErrorText>
        )}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processando…' : confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
